jQuery(document).ready(function(){
	jQuery('a').focus( function(){ 
      if( typeof jQuery(this).closest('.nav')[0] !== 'undefined' ){
    	var anchor = this;
      	if( jQuery(this).closest('.has_sub_menu').hasClass('nest') ){
          	jQuery(this).closest('.nav').find('.nest.show-submenu').removeClass('show-submenu');
        }else{
      		jQuery(this).closest('.nav').find('.show-submenu').removeClass('show-submenu');
        }
      	jQuery(this).closest('.has_sub_menu').addClass('show-submenu');
      }else{
        jQuery('.show-submenu').removeClass('show-submenu');
      }
    });

    jQuery('body').on('focus', '.dlink', function(){
        var activeNav = jQuery(this).closest('.nav');
        jQuery(activeNav).find('.show-menu').removeClass('show-menu');
    });
  
  
    jQuery('body').on('keypress', function(e){
      if(e.which == 13) {
         var activeEle = document.activeElement;
        if ( jQuery(activeEle).hasClass('dlink') ){
          var activeNav = jQuery(activeEle).closest('.nav');
          var closestSub = jQuery(activeEle).closest('.has_sub_menu');
          if( typeof jQuery(closestSub)[0] !== 'undefined' ){
            if( jQuery(closestSub).hasClass('show-menu') ){
              jQuery(closestSub).removeClass('show-menu');
            }else{
              jQuery(activeNav).find( '.show-menu' ).removeClass('show-menu');
              jQuery(closestSub).addClass('show-menu')
            }
          }
        }
      }
    });
  
    jQuery('body').on('blur', '.nspcc-cart-qty .cart-qty', function(){
      var cart_form = jQuery(this).closest('form');
      var currVal = jQuery(this).data('currval');
      if( typeof currVal === 'undefined' ){
       currVal = 1;
      }
      var inputVal = jQuery(this).val();
      if( typeof inputVal !== 'number' ){
        inputVal = parseInt( inputVal );
      }
      if( typeof currVal !== 'number' ){
        currVal = parseInt (currVal );
      }
      if( inputVal !== currVal ){
        cart_form.submit();
      }
    });
});


/* Filters */
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    jQuery(document).on('shopify:section:load', function(event) {
      jQuery('.sort-by').each(function(){
        var currSortBy = jQuery(this).data('current-sortby');
        jQuery(this).val(currSortBy)
           .bind('change', function() {
              Shopify.queryParams.sort_by = jQuery(this).val();
              location.search = jQuery.param(Shopify.queryParams);
           });
      });

    });



   /* Product Tag Filters - Good for any number of filters on any type of collection page.
       Give you product tag filter select element a class of coll-filter.
       Give your collection select a class of coll-picker.
       Brought to you by Caroline Schnapp. */
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    jQuery('.coll-picker').change(function() {
      if (jQuery(this).val()) {
        location.href = '/collections/' + jQuery(this).val();
      }
      else {
        location.href = '/collections/all';
      }
    });
    var collFilters = jQuery('.coll-filter');
    collFilters.change(function() {
      delete Shopify.queryParams.page;
      var newTags = [];
      collFilters.each(function() {
        if (jQuery(this).val()) {
          newTags.push(jQuery(this).val());
        }
      });
      
      if (newTags.length) {
        Shopify.queryParams.constraint = newTags.join('+');
      }
      else {
        delete Shopify.queryParams.constraint;
      }
      location.search = jQuery.param(Shopify.queryParams);
      
    });

jQuery(document).ready(function(event) {
  Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    jQuery('.coll-picker-22').change(function() {
      if (jQuery(this).val()) {
        location.href = jQuery(this).data('collection-url');
      }
      else {
        location.href = '/collections/all';
      }
    });
    var collFilters = jQuery('.coll-filter-22');
    collFilters.change(function() {
      delete Shopify.queryParams.page;
      var newTags = [];
      collFilters.each(function() {
        if (jQuery(this).val()) {
          newTags.push(jQuery(this).val());
        }
      });
      var newURL = jQuery(this).data('collection-url');
      if (newTags.length) {
        newURL += '/' + newTags.join('+');
      }
      var search = jQuery.param(Shopify.queryParams);
      if (search.length) {
        newURL += '?' + search;
      }
      location.href = newURL;
 
    });
});



jQuery(document).ready(function(){  
  
    jQuery('.sort-by').each(function(){
      var currSortBy = jQuery(this).data('current-sortby');
      jQuery(this).val(currSortBy)
         .bind('change', function() {
            Shopify.queryParams.sort_by = jQuery(this).val();
            location.search = jQuery.param(Shopify.queryParams);
         });
    });   
  
    jQuery('body').on( 'click', '.apply-checkbox-filters', function(){
      Shopify.queryParams = {};
        if (location.search.length) {
          for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
              Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      
      /* What is the proposed tag value */
      var tag_destination = [];
      jQuery('input.checkbox-filter').each(function(){
        if( jQuery(this).is(':checked') ){
          tag_destination.push( jQuery(this).val() );
        }
      });
      if( typeof jQuery(this).data('collection-url') !== 'undefined' ){
        var destination_url = jQuery(this).data('collection-url') + '/' + tag_destination.join('+');
        var search = jQuery.param(Shopify.queryParams);
        if (search.length) {
          destination_url += '?' + search;
        }
        window.location = destination_url;
      }
    });


  
});


/* Options panel render */
jQuery(document).ready(function(){
  if( typeof jQuery('.collections-options-panel')[0] !== 'undefined' ){
    var collections_options_panel = jQuery('.collections-options-panel')[0];
    if( typeof jQuery('.collection-option-container')[0] !== 'undefined'){
      /* foreach the containers and create elements */
      jQuery('.collection-option-container').each(function(){
        var cop_filters_applied = ': (none)';
        if( typeof jQuery(this).data('cocont-filters-applied') !== 'undefined' && jQuery(this).data('cocont-filters-applied') > 0 ){
          var cop_filters_applied = ': ('+jQuery(this).data('cocont-filters-applied')+')';
        }
        var labelRaw = jQuery(this).data('cocont-label');
        var esc = function(s){ var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };
        var cop_label = (labelRaw != null ? esc(String(labelRaw)) : '') + cop_filters_applied + ' <span class="open"><i class="fa fa-chevron-down"></i></span><span class="close"><i class="fa fa-chevron-up"></i></span>';
        var cop_src = jQuery(this).data('cocont-src');
        var cop_ele = jQuery('<div class="cop-element" tabindex="0" />').html(cop_label);
        jQuery(cop_ele).data('cocont-src',cop_src);
        jQuery(cop_ele).attr('data-cocont-trg',cop_src);
        jQuery(collections_options_panel).find('.cop-inner').append(jQuery(cop_ele));
      });
      jQuery('body').on('click', '.cop-element',function(){
        var target_ele = jQuery('[data-cocont-src="'+jQuery(this).data('cocont-src')+'"]');
        jQuery(target_ele).trigger('cocont-toggle');
      });
    jQuery('body').on('keypress', function(e){
      if(e.which == 13) {
        var activeEle = document.activeElement;
        if ( jQuery(activeEle).hasClass('cop-element') ){
          var target_ele = jQuery('[data-cocont-src="'+jQuery(activeEle).data('cocont-src')+'"]');
          jQuery(target_ele).trigger('cocont-toggle');            
        }        
      } 
    });
      
    }
    jQuery('.collection-option-container').on('cocont-toggle', function(){  
        if( jQuery(this).hasClass('cocont-open') ){
          jQuery(this).removeClass('cocont-open');
          jQuery('[data-cocont-trg="'+jQuery(this).data('cocont-src')+'"]').removeClass('cocont-open');
          jQuery(this).css( 'max-height', 0 );
          jQuery(this).hide();
        }else{
          jQuery(this).show();
          jQuery(this).css( 'max-height', jQuery(this).prop('scrollHeight') );
          jQuery(this).addClass('cocont-open');
          jQuery('[data-cocont-trg="'+jQuery(this).data('cocont-src')+'"]').addClass('cocont-open');
        }      
    });
  }

  if( typeof jQuery('#pagination').find('.count')[0] !== 'undefined' && jQuery('.cop-item-count')[0] !== 'undefined' ){
    jQuery('.cop-item-count').html(jQuery('#pagination').find('.count').html() );
  }
  
});

/* Sidebar panel render */
jQuery(document).ready(function(){
  
  jQuery('body').on('click','.nspcc-toggle-accordian .controller', function(e){
    jQuery(this).trigger('accordian-toggle');
  });
  jQuery('body').on('keypress', function(e){
    if(e.which == 13) {
      var activeEle = document.activeElement;
      if ( jQuery(activeEle).hasClass('controller') ){
        jQuery(activeEle).trigger('accordian-toggle');           
      }        
    } 
  });  
  jQuery('body').on('accordian-toggle','.nspcc-toggle-accordian .controller', function(e){
      var nta = jQuery(this).closest('.nspcc-toggle-accordian');
      var nta_target = jQuery(this).data('open-target');
      if( typeof jQuery(nta).find(nta_target)[0] === 'undefined' ){
        return false;
      }
      if( jQuery(nta).find(nta_target).hasClass('nta-open') ){
        jQuery(nta).find(nta_target).removeClass('nta-open');
        jQuery(nta).find(nta_target).css({height: 0});
      }else{
        jQuery(nta).find(nta_target).addClass('nta-open');
        var internalHeight = 0;
        var nta_target_children = jQuery(nta_target).children();
        jQuery(nta_target_children).each(function(){
          internalHeight = internalHeight + jQuery(this).outerHeight(true);
        });
        jQuery(nta).find(nta_target).css({height: internalHeight});
      }
  });

  jQuery('body').on('click','.nspcc-toggle-accordian-sf .controller', function(e){
    jQuery(this).trigger('accordian-toggle-sf');
  });
  jQuery('body').on('keypress', function(e){
    if(e.which == 13) {
      var activeEle = document.activeElement;
      if ( jQuery(activeEle).hasClass('controller') ){
        jQuery(activeEle).trigger('accordian-toggle-sf');           
      }        
    } 
  });  
  
  jQuery('body').on('accordian-toggle-sf','.nspcc-toggle-accordian-sf .controller', function(e){
      var nta = jQuery(this).closest('.nspcc-toggle-accordian-sf');
      var nta_target = jQuery(this).data('open-target');
      if( typeof jQuery(nta).find(nta_target)[0] === 'undefined' ){
        return false;
      }
      if( jQuery(nta).find(nta_target).hasClass('nta-open') ){
        jQuery(nta).find(nta_target).removeClass('nta-open');
        jQuery(nta).find(nta_target).css({height: 0});
      }else{
        jQuery(nta).find(nta_target).addClass('nta-open');
        var internalHeight = 0;
        var nta_target_children = jQuery(nta_target).children();
        jQuery(nta_target_children).each(function(){
          internalHeight = internalHeight + jQuery(this).outerHeight(true);
        });
        jQuery(nta).find(nta_target).css({height: internalHeight});
      }
  });

  
});

/* Capture empty searches */
jQuery( document ).ready(function(){
  jQuery('form.filter-form, form[action="/search"]').submit(function(e){
    if( jQuery(this).find('input[name="q"]').val() === "" ){
      e.preventDefault();
      jQuery(this).find('input[name="q"]').val('.');
      jQuery(this).submit();
    }
  });
});

/* Make full slide clickable */
jQuery( document ).ready(function(){
  jQuery('.slide-full-link').click( function(){
      if( typeof jQuery( this ).find('a')[0] !== 'undefined' ){
        window.location = jQuery(this).find('a').attr('href');
      } 
  });
});

/* Make collections a slider */

jQuery( document ).ready( function (){
  jQuery('.slider-enabled.product-loop').each( function(){
    var PLslider = this;
    var itemD= jQuery(this).data('desktop-items');
    var itemM= jQuery(this).data('mobile-items');
    var controller = jQuery(this).closest('.slider-container').find('.slider-controls')[0];
    var PLsliderOpts = {
      'container': PLslider,
      'items': itemM,
      'autoplay': false,
      'gutter': 10,
      'navPosition': 'bottom',
      'mouseDrag': true,
      'controlsPosition': 'bottom',
      'controlsContainer': controller,
      'arrowKeys': true,
      'responsive': {
        '741': {
          'items': itemD
        }
      }
    };
    tns(PLsliderOpts);
  });
});